import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * بيسجّل كل صفحة بتتفتح في المتجر (لإحصائيات الزيارات في لوحة التحكم).
 * السيرفر بيحسب زيارة فريدة واحدة لكل IP في اليوم، والباقي مشاهدات صفحات.
 */
const VisitTracker = () => {
  const { pathname } = useLocation();
  const { token, loading } = useAuth();
  const lastPath = useRef(null);
  const isFirst = useRef(true);

  useEffect(() => {
    if (loading || lastPath.current === pathname) return;
    lastPath.current = pathname;

    // المصدر الخارجي (جوجل/انستقرام...) بيتبعت مع أول صفحة بس
    const referrer = isFirst.current ? document.referrer || null : null;
    isFirst.current = false;

    fetch(`${API}/track`, {
      method: 'POST',
      keepalive: true,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({ path: pathname, referrer }),
    }).catch(() => {});
  }, [pathname, loading, token]);

  return null;
};

export default VisitTracker;
